


















# Mapping of Craft _typename to component
export mapping =
	blocks_copy_BlockType: 'blocks-copy'
	blocks_mediaAsset_BlockType: 'blocks-media-asset'
	blocks_standardMarquee_BlockType: 'blocks-standard-marquee'
	blocks_scrollingMarquee_BlockType: 'blocks-scrolling-marquee'
	blocks_featureTout_BlockType: 'blocks-feature-tout'
	blocks_spacer_BlockType: 'blocks-spacer'
	blocks_wrapper_BlockType: 'blocks-wrapper'
	blocks_accordionWrapper_BlockType: 'blocks-accordion-wrapper'
	blocks_faqListing_BlockType: 'blocks-faq-listing'
	blocks_buttonList_BlockType: 'blocks-button-list'
	blocks_productCarousel_BlockType: 'blocks-product-carousel'
	blocks_manualProductCarousel_BlockType: 'blocks-manual-product-carousel'
	blocks_categoryCarousel_BlockType: 'blocks-category-carousel'
	blocks_cardCarousel_BlockType: 'blocks-card-carousel'
	blocks_marqueeCarousel_BlockType: 'blocks-marquee-carousel'
	blocks_categorySummary_BlockType: 'blocks-category-summary'
	blocks_categoryMenu_BlockType: 'blocks-category-menu'
	blocks_postListing_BlockType: 'blocks-post-listing'
	blocks_pressReleaseListing_BlockType: 'blocks-press-release-listing'
	blocks_inTheNewsListing_BlockType: 'blocks-in-the-news-listing'
	blocks_iconGrid_BlockType: 'blocks-icon-grid'
	blocks_imageGrid_BlockType: 'blocks-image-grid'
	blocks_productGrid_BlockType: 'blocks-product-grid'
	blocks_logoGarden_BlockType: 'blocks-logo-garden'
	blocks_tabbedWrapper_BlockType: 'blocks-tabbed-wrapper'
	blocks_storeLocator_BlockType: 'blocks-store-locator'
	blocks_html_BlockType: 'blocks-html'
	blocks_productListing_BlockType: 'blocks-product-listing'
	blocks_productReviews_BlockType: 'blocks-product-reviews'

# Hard import marquee components so they don't get chunked
import '~/components/blocks/standard-marquee'
import '~/components/blocks/spacer'

# Component def for this block
export default
	name: 'BlockList'

	components: {
		...mapping
	}

	props:
		blocks: Array
		block: Object # Used by reusable sections

		# Used by Wrapper so the children don't get an offset of zero and disable
		# lazly loading. Note, this isn't perfect because any blocks after the
		# wrapper block won't currently be offset by the preceeding wrapper's
		# children count, but it works for our simple need of enabling lazy loading.
		indexOffset:
			type: Number
			default: 0

	computed:

		# Get the list of blocks from multiple props or default to an empty array
		blocksSource: -> @block?.reusableSection?[0]?.blocks || @blocks || []

		# Filter the blocks to those that have been defined.  To fix errors in dev
		# environments after content model is created but commits with the new
		# block component have not been pulled down.
		createdBlocks: ->
			@blocksSource.map (block) -> {
				...block
				componentName: switch block.__typename
					when 'blocks_reusableSection_BlockType' then 'blocks-list'
					else mapping[block.__typename]
			}
			.filter (block) -> !!block.componentName

